import React from "react";

import { RedirectMessage } from "@/components";
import { TRedirectStatus } from "@/components";

import { useConfirmAccount } from "./confirm-account.hooks";

export const ConfirmAccount: React.FC = () => {
  const { confirmStatus, confirmData, redirectMessageRef } =
    useConfirmAccount();

  return (
    <RedirectMessage
      ref={redirectMessageRef}
      redirectFunction={
        confirmData[confirmStatus as keyof typeof confirmData].function
      }
      type={confirmStatus as TRedirectStatus}
      message={confirmData[confirmStatus as keyof typeof confirmData].message}
      redirectTime={confirmData[confirmStatus as keyof typeof confirmData].time}
    />
  );
};
